import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiResponse } from "app/@core/types";
import { environment } from "environments/environment";
import { firstValueFrom } from "rxjs";
import { getErrorMessage } from "../utils/error-utils";

@Injectable({ providedIn: "root" })
export class PwycService {
  private http = inject(HttpClient);

  baseUrl: string = environment.baseUrl + "courses/";

  private _pwyccourses: Array<Array<number>> = [[33, 34, 35, 36], [54]];

  /**
   * For POST/PUT requests (Imperative Actions)
   */
  async skipPwyc<T>(data: any): Promise<T> {
    try {
      const res = await firstValueFrom(
        this.http.post<ApiResponse>(`${this.baseUrl}hcu/pwyc/skip`, data)
      );

      if (res.status === "ok") {
        return res.data as T;
      } else {
        throw new Error(getErrorMessage(res));
      }
    } catch (err) {
      throw new Error(getErrorMessage(err));
    }
  }

  async updatePwyc<T>(data: any): Promise<T> {
    try {
      const res = await firstValueFrom(
        this.http.post<ApiResponse>(`${this.baseUrl}hcu/pwyc`, data)
      );

      if (res.status === "ok") {
        return res.data as T;
      } else {
        throw new Error(getErrorMessage(res));
      }
    } catch (err) {
      throw new Error(getErrorMessage(err));
    }
  }

  // skipPwyc(nextdate: string, course: Course): Observable<ApiResponse> {
  //   return this.http
  //     .post<ApiResponse>(this.baseUrl + "hcu/pwyc/skip", {
  //       nextdate: nextdate,
  //       course: course.slug,
  //     })
  //     .pipe(
  //       map((result: ApiResponse) => {
  //         if (result.status == "ok") {
  //           this.updatePywcCurses(nextdate, course);
  //           return result;
  //         }
  //         return { msg: "Could not not skip payment", status: "error" };
  //       }),
  //       catchError(() => {
  //         // Handle network errors
  //         return of({
  //           msg: "Could not not skip payment",
  //           status: "error",
  //         } as ApiResponse);
  //       })
  //     );
  // }

  // updatePwyc(postData: Object, course: Course): Observable<ApiResponse> {
  //   return this.http.put<ApiResponse>(this.baseUrl + "hcu/pwyc", postData).pipe(
  //     tap((result) => {
  //       if (result.status == "ok") {
  //         this.updatePywcCurses("2031-12-31 23:59:59", course);
  //       }
  //     })
  //   );
  // }

  // updatePywcCurses(enddate: string, course: Course): void {
  //   // let ind = this._pwyccourses.findIndex((p) => p.includes(course.id));
  //   // if (ind > -1) {
  //   //   let pwyccourses = this._pwyccourses[ind];
  //   //   pwyccourses.forEach((id, index) => {
  //   //     const indx = this.coursesStore.courses.findIndex(
  //   //       (course: Course) => course.id === id
  //   //     );
  //   //     if (indx > -1) {
  //   //       const course = Object.assign(this.coursesStore.courses[indx], {
  //   //         course_enddate: enddate,
  //   //       });
  //   //       this.coursesStore.courses[indx] = course;
  //   //     }
  //   //   });
  //   //   this._courses.next(Object.assign({}, this.coursesStore).courses);
  //   // }
  // }
}
